// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__fKam3","checkboxContainer":"Checkbox_checkboxContainer__OvMcW"};